import { Recurso } from "lib.common/dist/CleanArch";
import {
  ErrExterno,
  ErrUsrNoEnontrado,
} from "lib.common/dist/errorHandler";
import { PaginationOptions } from "lib.common/dist/types";
import { ProductoDsTiendaRepository } from "../../business/repositories/ProductoDsTiendaRepository";
import { ProductoDsTiendaDtSource } from "../../business/dataSources/ProductoDsTiendaDtSource";
import { ProductoDsTiendaModel } from "../models/ProductoDsTiendaModel";
import { ProductoDsTienda } from "../../business/entities/ProductoDsTienda";

export class ProductoDsTiendaRepositoryImpl implements ProductoDsTiendaRepository<ProductoDsTiendaModel> {
  private readonly dataSource: ProductoDsTiendaDtSource;
  constructor(dataSource: ProductoDsTiendaDtSource) {
    this.dataSource = dataSource;
  }

  async getAllProductosDsTienda(
    pagination?: PaginationOptions,
    selectList?: string[],
    onlyDen?: boolean
  ): Promise<Recurso<ProductoDsTiendaModel[]>> {
    try {
      const response = await this.dataSource.getAllProductosDsTienda(
        pagination,
        selectList,
        onlyDen,
      );
      if (response.isSuccess()) {
        return Recurso.fromData<ProductoDsTiendaModel[]>(
                    response.data!.map(ProductoDsTiendaModel.deserialize)
                );
      }
      return Recurso.fromError<ProductoDsTiendaModel[]>(
        new ErrUsrNoEnontrado(response.error?.error)
      );
    } catch (error) {
      return Recurso.fromError(new ErrExterno(error as Error));
    }
    //
  }
}
